'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isFinite = require('babel-runtime/core-js/number/is-finite');

var _isFinite2 = _interopRequireDefault(_isFinite);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /*
                    * GoogleMap hover example
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _function = require('react-pure-render/function');

var _function2 = _interopRequireDefault(_function);

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _utils = require('google-map-react/utils');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _GoogleMapPin = require('../components/GoogleMapPin');

var _GoogleMapPin2 = _interopRequireDefault(_GoogleMapPin);

var _HotelItem = require('../containers/HotelItem.js');

var _HotelItem2 = _interopRequireDefault(_HotelItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var K_SIZE = 60;

function compareById(placeA, placeB) {
  return placeA.id.localeCompare(placeB.id);
}

var ZOOM = void 0;
if (__SERVER__) {
  ZOOM = 16;
} else {
  var TARGET = document.body.offsetWidth;

  ZOOM = TARGET < 2400 && TARGET > 1200 ? 16 : TARGET < 1200 && TARGET > 600 ? 15 : TARGET < 600 && TARGET > 300 ? 14 : TARGET > 2400 ? 17 : 13;
}

var GoogleMapPointPicker = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GoogleMapPointPicker, _Component);

  function GoogleMapPointPicker(props) {
    (0, _classCallCheck3.default)(this, GoogleMapPointPicker);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleMapPointPicker.__proto__ || (0, _getPrototypeOf2.default)(GoogleMapPointPicker)).call(this, props));

    _this.shouldComponentUpdate = _function2.default;

    _this._onChange = function () {};

    _this._onClick = function () {
      _this.setState({ clickKey: null, showPopup: false });
    };

    _this._onOrientationChange = function () {
      if (typeof _this.props.center !== 'undefined' && typeof _this.mapObject !== 'undefined') {
        _this.mapObject.setCenter({ lat: _this.props.center[0], lng: _this.props.center[1] });
      }
    };

    _this._onChildClick = function (clickKey, childProps) {
      _this.setState({
        clickKey: clickKey,
        showPopup: true
      });

      _this.mapObject.panTo({ lat: childProps.lat, lng: childProps.lng });
      _this.mapObject.panBy(0, -100);
    };

    _this._onChildMouseEnter = function (hoverKey /*, childProps */) {
      _this.setState({
        hoverKey: hoverKey
      });
    };

    _this._onChildMouseLeave = function () /* hoverKey, childProps */{
      _this.setState({
        hoverKey: null
      });
    };

    _this._onChildClick = _this._onChildClick.bind(_this);
    _this._onChildMouseEnter = _this._onChildMouseEnter.bind(_this);
    _this._onChildMouseLeave = _this._onChildMouseLeave.bind(_this);
    _this._onClick = _this._onClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(GoogleMapPointPicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var zoom = this.props.zoom;
      if (!this.props.places.length) {
        zoom = 1;
      }

      this.setState({
        zoom: zoom,
        hoverKey: this.props.hoverId,
        clickKey: null
      });
    }

    // XXX: checking element height is only available after the component is rendered
    /* eslint react/no-did-mount-set-state: "off" */
    // XXX: ref can be used to get the DOM element but cannot be used to get the DOM element of a React Component
    /* eslint react/no-find-dom-node: "off" */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var map = _reactDom2.default.findDOMNode(this.mapDOM);
      var size = {
        width: map.clientWidth,
        height: map.clientHeight
      };
      this.setState({ size: size });
      if (this.props.places.length > 1) {
        this.updateZoom(this.props.places, size);
      }

      window.addEventListener('orientationchange', this._onOrientationChange);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.places.length > 1 && !_lodash2.default.isEqual(this.props.places.sort(compareById), nextProps.places.sort(compareById))) {
        this.updateZoom(nextProps.places, this.state.size);
      }

      if (nextProps.hoverId) {
        this.setState({
          hoverKey: nextProps.hoverId
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._onOrientationChange) {
        window.removeEventListener('orientationchange', this._onOrientationChange);
      }
    }
  }, {
    key: 'updateZoom',
    value: function updateZoom(places, size) {
      if (this.props.noNeedToFitBounds || !this.props.center || !this.props.center.length) {
        return;
      }

      var bounds = {
        nw: {
          lat: this.props.center[0],
          lng: this.props.center[1]
        },
        se: {
          lat: this.props.center[0],
          lng: this.props.center[1]
        }
      };
      places.forEach(function (place) {
        bounds.nw.lat = bounds.nw.lat > place.lat ? bounds.nw.lat : place.lat;
        bounds.nw.lng = bounds.nw.lng < place.lng ? bounds.nw.lng : place.lng;
        bounds.se.lat = bounds.se.lat < place.lat ? bounds.se.lat : place.lat;
        bounds.se.lng = bounds.se.lng > place.lng ? bounds.se.lng : place.lng;
      });

      var _fitBounds = (0, _utils.fitBounds)(bounds, size),
          zoom = _fitBounds.zoom;

      if (!(0, _isFinite2.default)(zoom)) {
        zoom = this.props.zoom;
      }
      this.setState({ zoom: zoom });
    }

    // XXX: currently no need to handle boundary changes

    // _onChange = ({ center, zoom }) => {
    // this.setState({
    //   center: [center.lat, center.lng],
    //   zoom
    // });
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          center = _props.center,
          places = _props.places,
          disableUserInteraction = _props.disableUserInteraction,
          i18n = _props.i18n,
          location = _props.location,
          search = _props.search;
      var _state = this.state,
          zoom = _state.zoom,
          hoverKey = _state.hoverKey,
          clickKey = _state.clickKey,
          showPopup = _state.showPopup;

      var options = disableUserInteraction ? { panControl: false, scrollwheel: false, scaleControl: false, draggable: false, fullscreenControl: false } : { fullscreenControl: false };

      return _react2.default.createElement(
        _googleMapReact2.default,
        {
          ref: function ref(elem) {
            _this2.mapDOM = elem;
          }
          // [lat, lng] or { lat: lat, lng: lng} Default lat/lng at which to center the map - changing this prop throws a warning
          , center: center,
          zoom: zoom,
          hoverDistance: K_SIZE,
          onChange: this._onChange,
          onChildClick: this._onChildClick,
          onChildMouseEnter: this._onChildMouseEnter,
          onChildMouseLeave: this._onChildMouseLeave,
          options: options,
          onGoogleApiLoaded: function onGoogleApiLoaded(_ref) {
            var map = _ref.map;

            _this2.mapObject = map;
          },
          onClick: this._onClick,
          yesIWantToUseGoogleMapApiInternals: true
        },
        places.map(function (place) {
          var id = place.id,
              coords = (0, _objectWithoutProperties3.default)(place, ['id']);

          return _react2.default.createElement(_GoogleMapPin2.default, (0, _extends3.default)({
            key: id
          }, coords, {
            className: 'hint hint--html hint--info hint--top',
            highlight: place.highlighted,
            hover: hoverKey === id,
            clicked: clickKey === id,
            showPopup: showPopup,
            popup: _react2.default.createElement(_HotelItem2.default, { display: 'map', i18n: i18n, item: place, location: location, search: search })
          }));
        })
      );
    }
  }]);
  return GoogleMapPointPicker;
}(_react.Component), _class.propTypes = {
  center: _react.PropTypes.arrayOf(_react2.default.PropTypes.number), // @controllable
  zoom: _react.PropTypes.number, // @controllable
  disableUserInteraction: _react.PropTypes.bool,
  places: _react.PropTypes.array,
  i18n: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object.isRequired,
  search: _react.PropTypes.object.isRequired,
  hoverId: _react.PropTypes.string,
  noNeedToFitBounds: _react.PropTypes.bool
}, _class.defaultProps = {
  zoom: ZOOM,
  places: []
}, _temp);
exports.default = GoogleMapPointPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleMapPointPicker.js
// module id = 574
// module chunks = 0